/**
 * StoreFront Module
 * Main entry point for the store-front React application
 */

import React from 'react';

import { Link, Route, Routes } from 'react-router-dom';

// Page components
import { AuthBox } from './authentication/auth-box';
import { PinReset } from './authentication/pin-reset';
import { AuthGuard } from './components/auth-guard';
// Layout components
import { Header } from './components/header';
import { Loader } from './components/loader';
import { OffersLanding } from './offers/offers-landing';
import { routes } from './utils/routes';

/**
 * Welcome Page Component
 */
const WelcomePage: React.FC = () => (
    <div className="store-front__page">
        <AuthBox />
    </div>
);

/**
 * Forgot Password Page Component
 */
const ForgotPasswordPage: React.FC = () => (
    <div className="store-front__page">
        <PinReset />
    </div>
);

/**
 * Offers Page Component
 */
const OffersPage: React.FC = () => (
    <div className="store-front__page">
        <OffersLanding />
    </div>
);

/**
 * Not Found Page Component
 */
const NotFoundPage: React.FC = () => (
    <div className="store-front__page store-front__page--center">
        <div className="store-front__not-found">
            <h1>404</h1>
            <p>Page not found</p>
            <Link to={routes.WELCOME}>Go to Home</Link>
        </div>
    </div>
);

/**
 * Main StoreFront Application Component
 */
export const StoreFront: React.FC = () => {
    return (
        <div className="store-front">
            <Header />

            <main className="store-front__content">
                <Routes>
                    {/* Public routes */}
                    <Route path={routes.WELCOME} element={<WelcomePage />} />
                    <Route path={routes.FORGOT_PASSWORD} element={<ForgotPasswordPage />} />

                    {/* Protected routes */}
                    <Route element={<AuthGuard />}>
                        <Route path={routes.OFFERS} element={<OffersPage />} />
                        <Route path={routes.PRELOADER} element={<Loader fullPage pulse />} />
                    </Route>

                    {/* Catch all - 404 */}
                    <Route path="*" element={<NotFoundPage />} />
                </Routes>
            </main>
        </div>
    );
};

export default StoreFront;
